import { RATE_CATEGORY } from "@/constants/project-constant";
import { IReviewItem } from "Models";
import MeeyRate from "@/components/MeeyRate";
import clsx from "clsx";
import { useState } from "react";

const ReviewDetailRate = ({ data }: { data: IReviewItem }) => {
  const [expand, setExpand] = useState(false);
  return data.voteScore ? (
    <div
      key={data._id}
      className="p-2 bg-grey-50 rounded-lg text-fs-12 text-grey-600 cursor-pointer"
      onClick={() => setExpand((exp) => !exp)}
    >
      <div className="flex gap-2 items-center">
        <MeeyRate
          disable={true}
          value={data?.voteScore}
          itemClassName="!text-fs-24"
          className="h-5 items-center"
        />
        <div className="text-blue-500">Xem điểm chi tiết</div>
      </div>
      <div
        className={clsx(
          "flex gap-2 flex-wrap overflow-hidden duration-300 border-dashed ",
          expand ? "max-h-[10rem] pt-2  border-t mt-2" : "max-h-0"
        )}
      >
        {RATE_CATEGORY.filter(
          (cate) =>
            data.votes.find((item) => item.voteCategory === cate.key)?.score > 0
        ).map((cate) => (
          <div
            key={cate.key}
            className="px-2 py-0.5 rounded-full bg-grey-200 flex-[0_0_auto]"
          >
            {cate.title}:{" "}
            {data.votes.find((item) => item.voteCategory === cate.key)?.score}{" "}
            <i className="mrv mrv-star text-fs-12"></i>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default ReviewDetailRate;
